'use strict';

var Backbone = require('backbone');
var Router = require('base/Colido.Router');
var AppController = require('./controller');

/**
 * Global Colido Router
 *
 * @category   Router
 * @module     global
 * @copyright  Copyright (c) 2016, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 * @author     Stefan Rueschenberg <sr@h-m.io>
 */
var AppRouter = Router.extend({
    controller: new AppController(),

    appRoutes: {
        '*path/': 'removeTrailingSlash',
        '*notFound': 'notFound',
    },

    publicRoutes: [],

    exclusivelyPublicRoutes: [
        'login',
        'signup',
    ],

    before: function(params, next) {
        var route = Backbone.history.fragment;

        var isPublicRoute = _.any(this.publicRoutes, function(publicRoute){
            return route.match(publicRoute);
        });

        var isExclusivelyPublicRoute = _.contains(this.exclusivelyPublicRoutes, route);

        if (App.user.isLoggedIn) {
            if (isExclusivelyPublicRoute) {
                return this.navigate('', {trigger: true});
            }

            return next();
        } else {
            App.user.login({
                success: function() {
                    if (isExclusivelyPublicRoute) {
                        return App.router.navigate('', {trigger: true});
                    }

                    next();
                },
                error: function() {
                    if (isPublicRoute) {
                        return next();
                    }

                    if (route === '' || route === 'login/to' || route === 'login/to/') {
                        App.router.navigate('login', {trigger: true});
                    } else {
                        App.router.navigate('login/to/' + route, {trigger: true});
                    }
                },
            });
        }
    },

    addPublicRoutes: function(routes) {
        routes = _.isArray(routes) ? routes : [routes];

        this.publicRoutes = this.publicRoutes.concat(routes);
    },
});

module.exports = AppRouter;